import { DcBaseComponent } from '@deleteagency/dc';
import { deviceObserver } from '@deleteagency/device-observer';

const DESKTOP_COUNT = 5;
export default class GalleryComponent extends DcBaseComponent {
    static getNamespace() {
        return 'prop-gallery';
    }

    onInit() {
        if (this.refs.cell) {
            this._elementCounter();
            deviceObserver.subscribeOnResize(this._onResize);
        }
    }

    _onResize = () => {
        this._elementCounter();
    };

    _elementCounter() {
        this.elements = this.refs.cell;
        this.countText = this.refs.number;
        this.countCard = this.refs.count;
        this.totalCount = this.elements.length;
        this.count = 5;

        switch (true) {
            case deviceObserver.is('>', 'tablet'):
                this.count = 5;
                break;
            case deviceObserver.is('<=', 'tablet'):
                this.count = 7;
                break;
            default:
                break;
        }

        if (this.totalCount > this.count) {
            for (let i = 0; i < this.count; i++) {
                this.elements[i].classList.remove('hidden');
            }
            for (let i = this.count; i < this.elements.length; i++) {
                this.elements[i].classList.add('hidden');
            }
        } else {
            this.countCard.classList.add('hidden');
        }

        this.countText.innerHTML = Math.min(this.count, this.totalCount) + '/' + this.totalCount;

        this.countCard.dataset.dcPropertyCarTrigger = this.count;
    }
}
